import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/roboto-condensed/400.css';
import '@fontsource/roboto-condensed/700.css';
import '@fontsource/roboto/300.css';
// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { StyledEngineProvider } from '@mui/system';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { OpenFeatureBridge } from '@trm/feature-flags/web';
import { LDProvider } from 'launchdarkly-react-client-sdk';
// map
import 'mapbox-gl/dist/mapbox-gl.css';
import { createRoot } from 'react-dom/client';
// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
// apex-chart
import '~/assets/third-party/apex-chart.css';
import '~/assets/third-party/react-table.css';
import { ConfigProvider } from '~/contexts/ConfigContext';

// project import
import App from './App';
import './globalOverrides.css';
import reportWebVitals from './reportWebVitals';
import { createLaunchDarklyOptions, logLaunchDarklyMode } from './utils/launchDarklyOffline';

const container = document.getElementById('root');
const root = createRoot(container!);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

const launchDarklyClientSideId = process.env.LAUNCH_DARKLY_CLIENT_SIDE_ID ?? '';

// LaunchDarkly configuration with offline mode support
const launchDarklyOptions = createLaunchDarklyOptions(launchDarklyClientSideId);
logLaunchDarklyMode();

root.render(
  <LDProvider {...launchDarklyOptions}>
    <OpenFeatureBridge />
    <OpenFeatureProvider>
      <ConfigProvider>
        <StyledEngineProvider injectFirst>
          <App />
        </StyledEngineProvider>
      </ConfigProvider>
    </OpenFeatureProvider>
  </LDProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
